<template>
  <div>
    <div class="main">
      <router-view />
    </div>
    <div class="footer"  v-if="!$route.meta.hideFooter">
      <el-menu
        :default-active="active"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
        background-color="#343c6d"
        text-color="#fff"
        active-text-color="#ffd04b"
      >
        <!--        <el-menu-item index="/"><i class="el-icon-house"></i><p>首页</p></el-menu-item>-->
        <el-menu-item
          :style="{width: (100/menus.length)+'%'}"
          v-for="(menu, index) in menus"
          :key="index"
          :index="'/' + menu.index"
        >
          <i :class="menu.icon"></i>
          <p>{{ menu.label }}</p> 
         
        </el-menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getFrameMenus } from "@/assets/js/consult";
import HttpRequest from "../utils/request";
export default {
  name: "mainpage",
  data() {
    return {
      active: "/",
      menus: [],
      messageNum: null,
    };
  },
  computed: {
    ...mapState({
      student: state => state.user.student,
      admin: state => state.user.admin
    })
  },
  watch: {
    $route(to) {
      const currentPath = to.path.replace("/", "");
      const matchedMenu = this.menus.find(menu => menu.index === currentPath);
      this.active = matchedMenu ? `/${matchedMenu.index}` : (this.menus[0] ? `/${this.menus[0].index}` : "/");
    }
  },

  created() {
    if(this.admin.jsonSetting.consult_SmartPavilion == 1) {
      this.menus = []
    } else {
      this.menus = [
        { index: "home", icon: "el-icon-house", label: "首页" },
        { index: "allApplication", icon: "el-icon-document", label: "应用" },
        { index: "message", icon: "el-icon-chat-dot-round", label: "消息" },
        { index: "personalData", icon: "el-icon-user", label: "我" }
      ]
    }
    console.log('createdcreatedcreated')
    // if(this.menus.length > 0) {
    //   this.active = '/' + this.menus[0].index
    // }
    const currentPath = this.$route.path.replace("/", "");
    const matchedMenu = this.menus.find(menu => menu.index === currentPath);
    this.active = matchedMenu ? `/${matchedMenu.index}` : (this.menus[0] ? `/${this.menus[0].index}` : "/");
  },
  mounted() {
    console.log('mountedmountedmounted')
    // this.getMessageNum()
  },
  methods: {
    handleSelect(index, indexPath) {
      this.$router.push(index);
    },
    // getAdminMenu() {
    //   let consult_SmartPavilion = this.admin.jsonSetting.consult_SmartPavilion
    //   let open_homepage = this.admin.jsonSetting.open_homepage
    //   this.menus = getFrameMenus(consult_SmartPavilion ,open_homepage)
    //   this.active = '/' + this.menus[0].index
    // }
  }
};
</script>


<style scoped>
.el-menu--horizontal > .el-menu-item {
  line-height: 22px;
  text-align: center;
  padding: 8px 15px;
}

.el-menu-item [class^="el-icon-"] {
  margin: 0;
}

.item {
  position: absolute;
  top: -3px;
  right: 20%;
}

/* /deep/ .el-badge {
  top: -10px;
  left: 40px;
} */
</style>
